import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchAllSizeGroupings,
  fetchOneSizeGrouping,
  createSizeGrouping,
  updateSizeGrouping,
  deleteSizeGrouping,
} from "services/sizeGrouping";

export const useAllSizeGroupings = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["sizeGroupings", filters],
    queryFn: () => fetchAllSizeGroupings(filters),
    enabled,
  });
};

export const useOneSizeGrouping = (id, enabled = true) => {
  return useQuery({
    queryKey: ["sizeGrouping", id],
    queryFn: () => fetchOneSizeGrouping(id),
    enabled: Boolean(id) && enabled,
  });
};

export const useCreateSizeGrouping = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createSizeGrouping(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sizeGroupings"] });
    },
  });
};

export const useUpdateSizeGrouping = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateSizeGrouping(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["sizeGroupings"] });
      queryClient.invalidateQueries({ queryKey: ["sizeGrouping", variables.id] });
    },
  });
};

export const useDeleteSizeGrouping = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteSizeGrouping(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["sizeGroupings"] });
      queryClient.invalidateQueries({ queryKey: ["sizeGrouping", id] });
    },
  });
};
